import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Path,
  Svg,
  Circle as _Circle
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(_Circle, { cx: "8", cy: "18", r: "4", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M12 18V2l7 4", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Music2";
const Music2 = memo(themed(Icon));
export {
  Music2
};
//# sourceMappingURL=music-2.js.map
